import authentication from "@irati/auth";
export default (function () { return authentication.isGlobalAdmin(); });
